import React from "react"
import { Progress } from 'reactstrap';

const LinearProgressBar = ({ color, value }) => {
    return (
        <Progress color={color} value={value}>{value}%</Progress>
    )
}

export default LinearProgressBar